// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"JL-z","loadingMedia":"KL-z","reviewsImagesAndVideos":"LL-z","limitHeight":"ML-z"};